const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** Renders an ISO date/timestamp per the user-selected "Date Format (Report
 * Display)" control — a pure client-side formatting concern (§4.1.3's
 * DateFormat field never reaches the API; see po/sla filter schemas). */
export function formatDate(iso: string | null | undefined, format: string): string {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = String(d.getFullYear());
  const mmm = MONTHS[d.getMonth()];
  const sep = format.includes("-") ? "-" : "/";
  if (format.startsWith("DD") && format.includes("MMM")) return [dd, mmm, yyyy].join(sep);
  if (format.startsWith("MM")) return [mm, dd, yyyy].join(sep);
  return [dd, mm, yyyy].join(sep);
}
